var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Form, Modal, Select } from "semantic-ui-react";
import { RelevantCatalogType } from "../kit/automated-pro/RnaCatalog";
import { MetaCatalogLoader } from "../kit/Catalog";
import { LoadWrapper } from "../kit/rna-fish/LoadWrapper";
import { CatalogMode } from "../RequestHelpers";
import CreateOrderForUser from "./CreateOrderForUser";
var PRODUCT_OPTIONS = [
    { text: "HCR™ Gold RNA-FISH", value: "rna-fish" },
    { text: "HCR™ Pro RNA-ISH", value: "manual-pro" },
    { text: "HCR™ Gold IF", value: "manual-gold-if" },
];
var SAMPLE_TYPE_OPTIONS = [
    { text: "Whole-Mount", value: "WHOLE_MOUNT" },
    { text: "Tissue Section", value: "TISSUE_SECTION" },
    { text: "Cells on a Slide", value: "CELLS_SLIDE" },
    { text: "Cells in Suspension", value: "CELLS_SUSPENSION" },
];
var RNA_FISH_SAMPLE_TYPE_OPTIONS = SAMPLE_TYPE_OPTIONS.concat([
    { text: "Northern Blot", value: "NORTHERN_BLOT" },
]);
var ENCODER_SPECIES_OPTIONS = [
    { text: "Mouse IgG1", value: "MOUSE_IGG1" },
    { text: "Rabbit IgG", value: "RABBIT_IGG" },
];
var ManualStarterKitForm = /** @class */ (function (_super) {
    __extends(ManualStarterKitForm, _super);
    function ManualStarterKitForm(props) {
        var _this = _super.call(this, props) || this;
        _this.starterKitPage = function (catalog) {
            var _a, _b, _c, _d;
            var ampCatalog = catalog.rnaCatalog.proAmplifier;
            var amplifierOptions = ampCatalog.manualProAmps.proAmpConfigList.map(function (c) {
                return {
                    text: c.amplifier.id,
                    value: c.amplifier.id
                };
            });
            var requestBody = _this.requestBody();
            return React.createElement("div", { className: 'enzymatic-ish-form manual-starter-kit-form' },
                React.createElement("div", { className: 'manual-starter-kit-panel' },
                    React.createElement("div", { className: 'manual-starter-kit-heading' },
                        React.createElement("h1", { className: "ish-primary-header" }, "Manual Starter Kit Designer"),
                        React.createElement("h2", { className: "ish-subheader manual-starter-kit-subheader" }, "Build a manual starter kit for a customer")),
                    React.createElement(Form, { className: 'manual-starter-kit-fields' },
                        React.createElement(Form.Field, null,
                            React.createElement("label", { className: 'ish-subheader-tag' }, "Product"),
                            React.createElement(Select, { fluid: true, placeholder: 'Select a product...', options: PRODUCT_OPTIONS, value: (_a = _this.state.product) !== null && _a !== void 0 ? _a : '', onChange: _this.onProductChange })),
                        React.createElement(Form.Field, null,
                            React.createElement("label", { className: 'ish-subheader-tag' }, "Sample Type"),
                            React.createElement(Select, { fluid: true, placeholder: 'Select...', options: _this.sampleTypeOptionsForProduct(_this.state.product), value: (_b = _this.state.sampleType) !== null && _b !== void 0 ? _b : '', onChange: _this.onSampleTypeChange })),
                        _this.state.product === 'manual-gold-if' &&
                            React.createElement(Form.Field, null,
                                React.createElement("label", { className: 'ish-subheader-tag' }, "Encoder Species"),
                                React.createElement(Select, { fluid: true, placeholder: 'Select...', options: ENCODER_SPECIES_OPTIONS, value: (_c = _this.state.encoderSpecies) !== null && _c !== void 0 ? _c : '', onChange: _this.onEncoderSpeciesChange })),
                        _this.state.product === 'manual-pro' &&
                            React.createElement(Form.Field, null,
                                React.createElement("label", { className: 'ish-subheader-tag' }, "Amplifier System"),
                                React.createElement(Select, { fluid: true, placeholder: 'Select...', options: amplifierOptions, value: (_d = _this.state.amplifierSystem) !== null && _d !== void 0 ? _d : '', onChange: _this.onAmplifierSystemChange })),
                        React.createElement("div", { className: 'manual-starter-kit-actions' },
                            React.createElement(Modal, { closeIcon: true, onClose: _this.render, trigger: React.createElement(Button, { icon: 'magic', content: 'Create order for another user', labelPosition: 'left', disabled: requestBody === undefined }) },
                                React.createElement(Modal.Header, null, "Create an order from your cart for another user"),
                                React.createElement(Modal.Content, null,
                                    React.createElement(CreateOrderForUser, { manualStarterKitFormState: requestBody })))))));
        };
        _this.requestBody = function () {
            var sampleType = _this.state.sampleType;
            if (sampleType === undefined) {
                return undefined;
            }
            switch (_this.state.product) {
                case 'rna-fish':
                    return { _type: 'rna-fish', sampleType: sampleType };
                case 'manual-gold-if':
                    return _this.state.encoderSpecies === undefined
                        ? undefined
                        : { _type: 'manual-gold-if', sampleType: sampleType, encoderSpecies: _this.state.encoderSpecies };
                case 'manual-pro':
                    return _this.state.amplifierSystem === undefined
                        ? undefined
                        : { _type: 'manual-pro', sampleType: sampleType, amplifierSystem: _this.state.amplifierSystem };
                default:
                    return undefined;
            }
        };
        _this.onProductChange = function (_, data) {
            _this.setState(function (prev) {
                var product = data.value;
                var sampleType = _this.sampleTypeOptionsForProduct(product)
                    .some(function (option) { return option.value === prev.sampleType; })
                    ? prev.sampleType
                    : undefined;
                return {
                    product: product,
                    sampleType: sampleType,
                    encoderSpecies: undefined,
                    amplifierSystem: undefined
                };
            });
        };
        _this.onSampleTypeChange = function (_, data) {
            _this.setState(function () { return ({
                sampleType: data.value
            }); });
        };
        _this.onEncoderSpeciesChange = function (_, data) {
            _this.setState(function () { return ({
                encoderSpecies: data.value
            }); });
        };
        _this.onAmplifierSystemChange = function (_, data) {
            _this.setState(function () { return ({
                amplifierSystem: data.value
            }); });
        };
        _this.sampleTypeOptionsForProduct = function (product) {
            return product === "rna-fish"
                ? RNA_FISH_SAMPLE_TYPE_OPTIONS
                : SAMPLE_TYPE_OPTIONS;
        };
        _this.state = {
            product: undefined,
            sampleType: undefined,
            encoderSpecies: undefined,
            amplifierSystem: undefined
        };
        return _this;
    }
    ManualStarterKitForm.prototype.render = function () {
        return React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Consumer, RelevantCatalogType.Initial), render: this.starterKitPage });
    };
    return ManualStarterKitForm;
}(React.PureComponent));
export default ManualStarterKitForm;
//# sourceMappingURL=ManualStarterKitForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ManualStarterKitForm.js
// module id = 1471
// module chunks = 0